import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs, updateSiteConfiguration } from 'actions/Site'
import { fetchPakDeDownlineList } from 'actions/User'
import { pickBy, identity } from 'lodash'
import qs from 'query-string'
import PakDeDownlineView from 'components/pages/users/pakde'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  fetchPakDeDownlineList: bindActionCreators(fetchPakDeDownlineList, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
})

const dataStatusClaim = [
  { id: 1, label: 'Semua', value: '' },
  { id: 2, label: 'Sudah Klaim', value: 'sudah klaim' },
  { id: 3, label: 'Belum Klaim', value: 'belum klaim' },
]

const dataStatusIuran = [
  { id: 1, label: 'Semua', value: '' },
  { id: 2, label: 'Sudah Mengiur', value: 'sudah mengiur' },
  { id: 3, label: 'Belum Mengiur', value: 'belum mengiur' },
]

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('statusClaim', 'setStatusClaim', dataStatusClaim),
  withState('statusIuran', 'setStatusIuran', dataStatusIuran),
  withState('stateSearch', 'setStateSearch', {}),
  withState('dataPakD', 'setDataPakD', {
    data: [],
    meta: {},
    isFetching: true,
  }),
  withHandlers({
    getPakDeDownlineList: props => (params) => {
      const { match, setDataPakD } = props
      props.fetchPakDeDownlineList(match.params.id, params)
        .then((result) => {
          setDataPakD({
            data: result.data,
            meta: result.meta,
            isFetching: false,
          })
        })
        .catch(() => {
          setDataPakD({
            data: [],
            meta: {},
            isFetching: false,
          })
        })
    },
  }),
  withHandlers({
    onLoad: props => (isSearch) => {
      const {
        page, search, statusClaim, monthlyStatus,
      } = props.stateSearch
      const payload = {
        page: isSearch ? '' : page,
        search: search || '',
        claim_status: statusClaim || '',
        monthly_fee_status: monthlyStatus || '',
      }
      props.getPakDeDownlineList(`&${qs.stringify(pickBy(payload, identity))}`)
    },
  }),
  withHandlers({
    handleChangeStatusClaim: props => (val) => {
      const {
        onLoad, setStateSearch, stateSearch, setDataPakD,
      } = props
      setDataPakD({
        data: [],
        meta: {},
        isFetching: true,
      })
      setStateSearch({
        ...stateSearch,
        statusClaim: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleChangeStatusIuran: props => (val) => {
      const {
        onLoad, setStateSearch, stateSearch, setDataPakD,
      } = props
      setDataPakD({
        data: [],
        meta: {},
        isFetching: true,
      })
      setStateSearch({
        ...stateSearch,
        monthlyStatus: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleSearch: props => (val) => {
      const {
        onLoad, setStateSearch, stateSearch, setDataPakD,
      } = props
      setDataPakD({
        data: [],
        meta: {},
        isFetching: true,
      })
      setStateSearch({
        ...stateSearch,
        search: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handlePage: props => (val) => {
      const {
        onLoad, setStateSearch, stateSearch, setDataPakD,
      } = props
      setDataPakD({
        data: [],
        meta: {},
        isFetching: true,
      })
      setStateSearch({
        ...stateSearch,
        page: val,
      })
      setTimeout(() => {
        onLoad()
      }, 300)
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Member Management', 'Pak-D', 'List'])
      this.props.updateSiteConfigs({
        titlePage: 'Member Management - Pak-D',
        activePage: 'user',
        activeSubPage: 'user',
      })
      this.props.onLoad()
    },
  }),
)(PakDeDownlineView)
